import React from "react";
import cardiology from "../../../assets/images/Cardiology-img.png";

const ServiceCard = ({...props}) => {
  const { key, title, image, onClickCard } = props

  return (
    <div key={key} className="cursor-pointer" onClick={onClickCard}>
      <div className="relative h-64 w-full overflow-hidden rounded-lg shadow-md sm:h-72">
        <img
          src={image || cardiology}
          alt="service Img"
          className="h-full w-full object-cover"
        />
        <div className="absolute bottom-4 left-4 font-syne text-2xl font-semibold text-[#fff] drop-shadow">
          <span>{title}</span>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
